import { GenericTableOrderDirection } from './types'

export const getNewDirection = (order: GenericTableOrderDirection) => {
  if (order === 'asc') {
    return 'desc'
  }

  return 'asc'
}

export const getImage = (imagen: string) =>
  imagen && imagen.length > 0
    ? imagen
    : 'https://via.placeholder.com/150/e5e5e5/808080?text=Sin%20Imagen'
